import { RiEdit2Line } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import type React from "react";
import type {
	DealConstruction,
	DealConstructionContext
} from "~/models/DealConstruction";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./ConstructionNavigation.module.scss";

type Props = {
	dealConstructionContext: DealConstructionContext;
	detailPagePath: string;
	title: string;
};

export const ConstructionNavigation: React.FC<Props> = ({
	title,
	detailPagePath,
	dealConstructionContext
}: Props) => {
	const { totalAmountWithTax, dealConstructions } = dealConstructionContext;
	const estimationNum = dealConstructions.filter(
		(e: DealConstruction) => e.enabled
	).length;
	return (
		<div className={Styles.NavigationBlock}>
			<div className={Styles.IconWrapper}>
				<RiEdit2Line className={Styles.Icon} />
			</div>
			<div className={Styles.NavigationContent}>
				<div>
					<h4 className={Styles.Title}>{title}</h4>
					<div>
						{estimationNum}件（¥
						{toThousandSeparator(totalAmountWithTax)}
						）が施工対象となっています。
					</div>
				</div>
				<div className={Styles.DetailLinkBlock}>
					<Link className={Styles.DetailLink} href={detailPagePath}>
						明細画面
					</Link>
				</div>
			</div>
		</div>
	);
};
